(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ukswerve-home-film"] && !Shopify.designMode) return;
  try {
    (function(){
    function init(root){
      if(root.dataset.initialized)return;
      root.dataset.initialized='true';
      var video=root.querySelector('video'),toggle=root.querySelector('[data-film-toggle]'),text=root.querySelector('[data-film-text]'),icon=root.querySelector('[data-film-icon]'),state=root.querySelector('[data-film-state]'),progress=root.querySelector('[data-film-progress]');
      if(!video||!toggle)return;
      var reduced=matchMedia('(prefers-reduced-motion:reduce)'),connection=navigator.connection,manualPaused=false,manualPlay=false,visible=true,failed=false;
      video.muted=true;
      video.defaultMuted=true;
      video.playsInline=true;
      function update(){
        var playing=!video.paused&&!video.ended;
        root.dataset.playing=String(playing);
        text.textContent=playing?root.dataset.labelPause:root.dataset.labelPlay;
        icon.textContent=playing?'Ⅱ':'▶';
        toggle.setAttribute('aria-label',playing?root.dataset.labelPause:root.dataset.labelPlay);
        state.textContent=failed?root.dataset.labelUnavailable:playing?root.dataset.labelPlaying:video.currentTime>0?root.dataset.labelPaused:root.dataset.labelReady;
      }
      function allowed(){return root.dataset.autoplay==='true'&&!reduced.matches&&!(connection&&connection.saveData);}
      function sync(){
        if(failed)return;
        if(visible&&!document.hidden&&!manualPaused&&(manualPlay||allowed())){
          var attempt=video.play();
          if(attempt&&attempt.catch)attempt.catch(update);
        }else video.pause();
      }
      toggle.addEventListener('click',function(){
        if(video.paused){manualPaused=false;manualPlay=true;sync();}
        else{manualPaused=true;manualPlay=false;video.pause();}
      });
      video.addEventListener('playing',function(){root.dataset.ready='true';update();});
      video.addEventListener('pause',update);
      video.addEventListener('timeupdate',function(){if(video.duration)progress.style.setProperty('--film-progress',Math.min(1,video.currentTime/video.duration));});
      video.addEventListener('error',function(){failed=true;root.dataset.ready='false';toggle.disabled=true;update();});
      document.addEventListener('visibilitychange',sync);
      if(reduced.addEventListener)reduced.addEventListener('change',function(){manualPlay=false;sync();});
      if(connection&&connection.addEventListener)connection.addEventListener('change',sync);
      if('IntersectionObserver' in window){
        var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){visible=entry.isIntersecting;sync();});},{threshold:.15});
        observer.observe(root);
      }
      update();
      sync();
    }
    function scan(){document.querySelectorAll('[data-uks-film]').forEach(init);}
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan);else scan();
    document.addEventListener('shopify:section:load',scan);
  })();
  } catch(e) { console.error(e); }
})();

})();
